import {createFileRoute} from '@tanstack/react-router';

import DiagnosticReportSent from '@/practitioner/views/diagnosticReport/DiagnosticReportSent';

export const Route = createFileRoute('/(practitioner)/practitioner/diagnostic-report-sent')({
  component: DiagnosticReportSent
});
